module.exports = __webpack_public_path__ + "img/ic30Reservation.40fcadb4.svg";